type UiConfig = Parameters<typeof defineAppConfig>[0]['ui']

export const uiConfig: UiConfig = {
  colors: {
    primary: 'sky',
    neutral: 'neutral',
    tertiary: 'tertiary',
  },
  button: {
    variants: {
      size: {
        xl: {
          base: 'px-6',
        },
      },
    },
    defaultVariants: {
      size: 'xl',
    },
  },
  formField: {
    slots: {
      label: 'text-xs font-normal text-muted',
      error: 'mt-1 text-xs',
      help: 'mt-1 text-xs text-dimmed',
    },
  },
  input: {
    defaultVariants: {
      size: 'xl',
    },
  },

  inputTags: {
    defaultVariants: {
      size: 'xl',
    },
  },

  textarea: {
    defaultVariants: {
      size: 'xl',
    },
  },
  inputNumber: {
    defaultVariants: {
      size: 'xl',
    },
  },
  inputDate: {
    defaultVariants: {
      size: 'xl',
    },
  },
  select: {
    defaultVariants: {
      size: 'xl',
    },
  },
  selectMenu: {
    defaultVariants: {
      size: 'xl',
    },
  },
  table: {
    slots: {
      th: 'px-2 py-1 text-xs font-normal text-muted',
      td: 'px-2 py-4 text-highlighted',
    },
  },
  modal: {
    slots: {
      content: 'divide-none',
    },
  },
  slideover: {
    slots: {
      overlay: 'bg-black/40',
    },
  },
  header: {
    slots: {
      root: 'bg-default border-b border-default h-(--ui-header-height) sticky top-0 z-50',
    },
  },
}
